import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'adc-filter-popup',
  templateUrl: './adc-filter-popup.component.html',
  styleUrls: ['./adc-filter-popup.component.css'],
})
export class AdcFilterPopupComponent {
  @Input() filter!: any;

  @Output() removeFilterObject = new EventEmitter<any>();
  @Output() applyFilterObject = new EventEmitter<any>();
  public filteredData!: any;
  public filterdObj: any;
  public filterMenuVisible: boolean = true;
  public filterType = 'in'; // Default filter type
  public filterLabel: string = '';
  public dateValue: any;
  fromDateValue: any;
  toDateValue: any;
  selectedValues: any[] = [];
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.filter.filterMenuVisible = true;
    console.log(this.filter, 'filter');
    //this.filterMenuVisible = true;
    this.filterMenuVisible = this.filter.filterMenuVisible;
    if (this.filter.type === 'list') {
      this.filterType = 'in';
      this.filteredData = this.filter.data;
      this.filterdObj = this.filteredData;
      this.selectedValues = this.filteredData
        .filter((item: { selected: any }) => item.selected)
        .map((item: { value: any }) => item.value);
    } else {
      this.filterType = 'eq';
      console.log(this.filter, 'trybuh');
      this.dateValue = this.filter?.conditionValue[0];
      this.selectedValues = [];
      this.apply();
      //this.selectedValues =  this.filter.conditionValue;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter'] && changes['filter'].currentValue) {
      if (changes['filter'].currentValue.data) {
        this.filteredData = changes['filter'].currentValue.data;
        this.filterdObj = this.filteredData;
        this.filterType = this.filter.condition;

        if (this.filter.type != 'list') {
          this.dateValue = this.filter.conditionValue[0];
          // this.selectedValues.push(this.filter.conditionValue[0])
          this.selectedValues = [];
          this.selectedValues = this.filter.conditionValue;
        } else {
          this.updatefilterCondition(this.filter.conditionValue);
        }
        this.cdr.detectChanges();
      }
    }
    this.apply();
  }

  selectAndDeselectAll(event: any) {
    const checkbox = event.target as HTMLInputElement;
    if(checkbox.checked) {
      this.filteredData.forEach((data: { selected: boolean; value: any; }) => {
        data.selected = true;
        if (!this.selectedValues.includes(data.value)) {
          this.selectedValues.push(data.value);
        }
      });
    } else {
      this.selectedValues = [];
      this.filteredData.forEach((data: { selected: boolean; }) => data.selected = false);
    }
  }

  updatefilterCondition(conditionValue: any[]) {
    this.filteredData.forEach((item: { selected: any; value: any }) => {
      item.selected = conditionValue.includes(item.value);
    });

    this.selectedValues = this.filteredData
      .filter((item: { selected: any }) => item.selected)
      .map((item: { value: any }) => item.value);
  }

  updateSelectedValues(data: any) {
    if (data.selected) {
      this.selectedValues.push(data.value);
    } else {
      this.selectedValues = this.selectedValues.filter(
        (value: any) => value !== data.value
      );
    }
  }

  removeSelectedValue(value: string) {
    this.selectedValues = this.selectedValues.filter(
      (selectedValue: string) => selectedValue !== value
    );
    const item = this.filteredData.find(
      (data: { value: string }) => data.value === value
    );
    if (item) {
      item.selected = false;
    }
  }

  clearSelectedValues() {
    this.selectedValues = [];
    this.filteredData.forEach(
      (data: { selected: boolean }) => (data.selected = false)
    );
  }

  applyFilter(event: Event) {
    this.filter.filterMenuVisible = false;
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    console.log(filterValue);
    if (this.selectedValues.includes(filterValue)) {
      this.selectedValues.filter((i: any) => filterValue != i);
    } else {
      this.selectedValues.push(filterValue);
    }
    // this.filteredData = this.filterdObj.filter((filter: { value: { toString: () => string; }; }) => {
    //   const filterText = filter.value.toString().toLowerCase();
    //   return filterText.includes(filterValue);
    // });
  }
  selectAll() {
    this.filteredData.forEach((data: { selected: boolean; value: any }) => {
      data.selected = true;
      if (!this.selectedValues.includes(data.value)) {
        this.selectedValues.push(data.value);
      }
    });
  }

  selectNone() {
    this.filteredData.forEach(
      (filterObj: { selected: boolean }) => (filterObj.selected = false)
    );
    this.selectedValues = [];
  }

  cancel() {
    // Implement cancel functionality
    this.filterMenuVisible = false;
    const emittedObject: any = {};
    emittedObject.filterMenuVisible = this.filterMenuVisible;
    emittedObject.filter = this.filter;
    this.removeFilterObject.emit(emittedObject);
  }

  apply() {
    this.filterMenuVisible = false;
    const emittedObject: any = {};
    emittedObject.filterMenuVisible = this.filterMenuVisible;
    emittedObject.filter = this.filter;
    if (this.fromDateValue != undefined && this.toDateValue != undefined) {
      if (this.fromDateValue == this.toDateValue) {
        this.selectedValues.push({ from: this.fromDateValue });
      } else {
        this.selectedValues.push({
          from: this.fromDateValue,
          to: this.toDateValue,
        });
      }
    }
    emittedObject.selectedValues = this.selectedValues;

    const objectFilter: any = {};
    objectFilter.field = this.filter.field;
    objectFilter.condition = this.filterType;
    objectFilter.conditionValue = this.selectedValues;
    emittedObject.filteredObject = objectFilter;
    this.applyFilterObject.emit(emittedObject);

    console.log(emittedObject);
  }
}
